import { Icon } from '@chakra-ui/react';

/** Same SVG as the icon, for use as Google Maps marker image (data URL) */
const PIN_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 35" fill="none">' +
  '<path d="M6.89307 25.9272C7.92961 27.2172 8.873 28.576 9.71641 29.9939C10.4365 31.3273 10.7367 32.2315 11.263 33.8381C11.5857 34.7258 11.8774 34.9907 12.5046 34.9907C13.188 34.9907 13.498 34.54 13.7376 33.843C14.2351 32.3257 14.6254 31.1677 15.2412 30.0736C16.4496 27.9612 17.9512 26.0841 19.4266 24.28C19.826 23.7694 22.4084 20.7948 23.571 18.4477C23.571 18.4477 24.9999 15.8694 24.9999 12.2686C24.9999 8.90039 23.5907 6.56436 23.5907 6.56436L19.5336 7.62542L17.0697 13.9627L16.4602 14.8366L16.3383 14.9949L16.1762 15.1931L15.8916 15.5096L15.485 15.9066L13.2909 17.6522L7.80557 20.7452L6.89307 25.9272Z" fill="#1F1F1F"/>' +
  '<path d="M1.23164 18.0142C2.57041 21.0005 5.15205 23.6256 6.89873 25.9293L16.1762 15.1972C16.1762 15.1972 14.8691 16.8665 12.4982 16.8665C9.85732 16.8665 7.72383 14.807 7.72383 12.2101C7.72383 10.4293 8.8209 9.20595 8.8209 9.20595L2.52314 10.8539L1.23164 18.0142Z" fill="#1F1F1F"/>' +
  '<path d="M16.2798 0.551894C19.361 1.52207 21.9983 3.55884 23.5936 6.56226L16.179 15.191C16.179 15.191 17.2761 13.9454 17.2761 12.1757C17.2761 9.51838 14.9848 7.5332 12.5095 7.5332C10.1687 7.5332 8.82441 9.19975 8.82441 9.19975V3.76379L16.2798 0.551894Z" fill="#1F1F1F"/>' +
  '<path d="M2.93115 4.36451C4.77148 2.21425 8.00976 0 12.4742 0C14.6402 0 16.2721 0.555327 16.2721 0.555327L8.81738 9.20452H3.53564L2.93115 4.36451Z" fill="#1F1F1F"/>' +
  '<path d="M1.23164 18.0142C1.23164 18.0142 0 15.6588 0 12.2466C0 9.02151 1.28379 6.20244 2.93115 4.36451L8.8209 9.20595L1.23164 18.0142Z" fill="#1F1F1F"/>' +
  '</svg>';

export const customPinIconDataUrl =
  'data:image/svg+xml,' + encodeURIComponent(PIN_SVG);

export const MAP_PIN_HEAD_CENTER_VIEWBOX = { x: 12.5, y: 9 };
export const MAP_PIN_VIEWBOX = { width: 25, height: 35 };
export const MAP_PIN_ANCHOR_NUDGE_UP_PX = 15;

const CustomPinIcon = (props) => {
  return (
    <Icon viewBox="0 0 25 35" fill="none" {...props}>
      <path
        d="M6.89307 25.9272C7.92961 27.2172 8.873 28.576 9.71641 29.9939C10.4365 31.3273 10.7367 32.2315 11.263 33.8381C11.5857 34.7258 11.8774 34.9907 12.5046 34.9907C13.188 34.9907 13.498 34.54 13.7376 33.843C14.2351 32.3257 14.6254 31.1677 15.2412 30.0736C16.4496 27.9612 17.9512 26.0841 19.4266 24.28C19.826 23.7694 22.4084 20.7948 23.571 18.4477C23.571 18.4477 24.9999 15.8694 24.9999 12.2686C24.9999 8.90039 23.5907 6.56436 23.5907 6.56436L19.5336 7.62542L17.0697 13.9627L16.4602 14.8366L16.3383 14.9949L16.1762 15.1931L15.8916 15.5096L15.485 15.9066L13.2909 17.6522L7.80557 20.7452L6.89307 25.9272Z"
        fill="#1F1F1F"
      />
      <path
        d="M1.23164 18.0142C2.57041 21.0005 5.15205 23.6256 6.89873 25.9293L16.1762 15.1972C16.1762 15.1972 14.8691 16.8665 12.4982 16.8665C9.85732 16.8665 7.72383 14.807 7.72383 12.2101C7.72383 10.4293 8.8209 9.20595 8.8209 9.20595L2.52314 10.8539L1.23164 18.0142Z"
        fill="#1F1F1F"
      />
      <path
        d="M16.2798 0.551894C19.361 1.52207 21.9983 3.55884 23.5936 6.56226L16.179 15.191C16.179 15.191 17.2761 13.9454 17.2761 12.1757C17.2761 9.51838 14.9848 7.5332 12.5095 7.5332C10.1687 7.5332 8.82441 9.19975 8.82441 9.19975V3.76379L16.2798 0.551894Z"
        fill="#1F1F1F"
      />
      <path
        d="M2.93115 4.36451C4.77148 2.21425 8.00976 0 12.4742 0C14.6402 0 16.2721 0.555327 16.2721 0.555327L8.81738 9.20452H3.53564L2.93115 4.36451Z"
        fill="#1F1F1F"
      />
      <path
        d="M1.23164 18.0142C1.23164 18.0142 0 15.6588 0 12.2466C0 9.02151 1.28379 6.20244 2.93115 4.36451L8.8209 9.20595L1.23164 18.0142Z"
        fill="#1F1F1F"
      />
    </Icon>
  );
};

export default CustomPinIcon;
